module.exports = __webpack_public_path__ + "img/BIRD SHADES GREEN.dda8b4d.svg";